import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING, ASC } from "const"
import { MtStudy } from "server/models"
import { StateType, hasProjectAccess } from "client/utils"
import {
    PRM_STUDY_SESSION,
    StoreType,
    StudyTeamMemberList,
    StudyTeamMemberListByStudy,
    StudySessionProps,

    LoadAllStudies,
    LoadAllStudyTeamMembers,
    LoadStudySessionById,
    SortStudies,
    SortStudyTeamMembers,

    setStudyList,
    setStudyIds,
    setStudyTeamMemberList,
    setStudyTeamMemberListByStudy,
    setStudySessionEdit,
    setStudySessionReloadEdit,
    initStudySession,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    sessionId = null,
}: StudySessionProps) => {
    const session = useSelector((state: StoreType) => state.studySession.sessionEdit)
    const reloadEdit = useSelector((state: StoreType) => state.studySession.reloadEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setStudySessionReloadEdit(false))
        setTimeout(() => {
            dispatch(setStudySessionReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        const promiseArray: Promise<any>[] = [
            LoadAllStudies(project.id).then((studyList) => {
                const studies: MtStudy[] = Object.values(studyList)
                const studyIds = SortStudies(studies, "name", ASC, {})
                dispatch(setStudyList(studyList))
                dispatch(setStudyIds(studyIds))

                let teamMemberList: StudyTeamMemberList = {}
                const teamMemberListByStudy: StudyTeamMemberListByStudy = {}

                const nestedPromiseArray: Promise<any>[] = []
                studies.forEach((study) => {
                    nestedPromiseArray.push(
                        LoadAllStudyTeamMembers(study.id).then((res) => {
                            teamMemberList = {
                                ...teamMemberList,
                                ...res,
                            }
                            const teamMemberIds = SortStudyTeamMembers(Object.values(res), "name", ASC, {})
                            teamMemberListByStudy[study.id] = teamMemberIds
                        }),
                    )
                })

                return Promise.all(nestedPromiseArray).then(() => {
                    dispatch(setStudyTeamMemberList(teamMemberList))
                    dispatch(setStudyTeamMemberListByStudy(teamMemberListByStudy))
                })
            }),
        ]

        if (sessionId === 0) {
            dispatch(setStudySessionEdit(initStudySession))
        } else {
            promiseArray.push(
                LoadStudySessionById(sessionId, project.id).then((res) => {
                    dispatch(setStudySessionEdit(res))
                }),
            )
        }

        setLoadState(PENDING)
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
            reload()
        })
    }, [])

    const addAccess = hasProjectAccess(PRM_STUDY_SESSION, ADD)
    const editAccess = hasProjectAccess(PRM_STUDY_SESSION, EDIT)

    if (sessionId === 0 && !addAccess) return <AccessDenied />
    if (sessionId !== 0 && !editAccess) return <AccessDenied />
    if (!session) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{session.id ? `${lang.editSession} # ${session.id}` : lang.addSession}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form session={session} />
                }
                {
                    reloadEdit
                    && <Form session={session} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
